import React from 'react';
import { colors } from '../theme';
import IProps from './interface';

const CallIcon = ({
  color = colors.black,
  className,
  onClick,
  size = 16,
}: IProps) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      onClick={onClick}
    >
      <path
        d="M3.15219 2.19968C3.97042 1.53247 5.17763 1.58058 5.94028 2.34323L6.72251 3.12546L6.84653 3.26315C7.42332 3.97261 7.3342 4.98825 6.66587 5.65671L6.24008 6.08151C6.59162 6.82626 7.10073 7.56423 7.7684 8.2319C8.43597 8.89947 9.17425 9.40809 9.9188 9.76022L10.3993 9.27975L10.5321 9.15964C11.2193 8.59794 12.2341 8.63806 12.8749 9.27878L13.6571 10.061L13.7997 10.2192C14.4226 10.9829 14.4227 12.0854 13.7997 12.8491L13.6571 13.0073L13.2225 13.4409C12.5852 14.0782 11.6948 14.356 10.8153 14.2426L10.6395 14.2143C8.72938 13.8532 6.69052 12.7575 4.96665 11.0337C3.35046 9.41747 2.28637 7.52445 1.86215 5.72018L1.78598 5.36081C1.60952 4.42553 1.87965 3.45757 2.55942 2.7778L2.99399 2.34323L3.15219 2.19968ZM4.87973 3.40378C4.68053 3.20458 4.37266 3.17936 4.14633 3.32858L4.05454 3.40378L3.61997 3.83835C3.31173 4.14658 3.16942 4.60443 3.25962 5.08249L3.32309 5.37936C3.6759 6.87691 4.58209 8.52801 6.02719 9.97311C7.5685 11.5144 9.34406 12.4431 10.9178 12.7407L11.0965 12.7632C11.5084 12.7921 11.8924 12.6499 12.162 12.3803L12.5956 11.9467L12.6707 11.8549C12.7988 11.661 12.7988 11.4074 12.6707 11.2133L12.5956 11.1216L11.8143 10.3393C11.7286 10.2536 11.5963 10.2434 11.4999 10.3071L11.4608 10.3393L10.8582 10.9428C10.5111 11.2896 9.96556 11.4251 9.47446 11.2085C8.50193 10.7788 7.55071 10.1373 6.70688 9.29343C5.96819 8.55473 5.38541 7.73431 4.96372 6.88913L4.79282 6.52585C4.57619 6.03464 4.71244 5.48912 5.05942 5.14206L5.60532 4.59616L5.66489 4.52585C5.71265 4.4571 5.72713 4.39496 5.72837 4.35007C5.72958 4.30516 5.71798 4.26272 5.69223 4.22409L5.66196 4.186L4.87973 3.40378Z"
        fill={color}
      />
    </svg>
  );
};

export default CallIcon;
